export const BANKS_WITH_SECONDARY_LANGUAGE = ["3480", "3890"];
export const NORNE_CENTERID = "0000";
export const NORNE_BANK_ACCOUNT_NUMBER = "3624.27.98605";
